import * as d3 from 'd3'

export default {
  methods: {

    draw_Header() {

      let head = this.header
      let col = this.columns
      let ty_ = 0

      let header = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.funcY})`)

      this.draw_Line(header, 0, head.width, 0, 0, '#757575')
      this.draw_Line(header, 0, head.width, head.height, head.height, '#757575')
      this.draw_Line(header, 0, head.width, this.table.height, this.table.height, '#757575')
     
      // Depth 1
      ty_ = head.tY[0]
      this.draw_Text(header, '', col[3].mx, ty_,  head.tSize[0], head.tColor[0], 'middle', 'This Week')
      this.draw_Text(header, '', col[6].sx + (head.width-col[6].sx)/2, ty_, head.tSize[0], head.tColor[0], 'middle', 'Cumulative Progress(%)')

      this.draw_Line(header, col[1].sx, head.width, head.depths[1], head.depths[1], '#bcbcbc')
      
      // Depth 2
      ty_ = head.tY[1]
      this.draw_Text(header, '', (col[1].sx + (col[2].ex-col[1].sx)/2), ty_, head.tSize[1], head.tColor[1], 'middle', 'Plan')
      this.draw_Text(header, '', col[3].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Actual')
      this.draw_Text(header, '', (col[4].sx + (col[5].ex-col[4].sx)/2), ty_, head.tSize[1], head.tColor[1], 'middle', 'Delta')

      this.draw_Text(header, '', (col[6].sx + (col[7].ex-col[6].sx)/2), ty_, head.tSize[1], head.tColor[1], 'middle', 'Plan')
      this.draw_Text(header, '', (col[8].sx + (col[9].ex-col[8].sx)/2), ty_, head.tSize[1], head.tColor[1], 'middle', 'Delta')
      this.draw_Text(header, '', col[10].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Progress(%)')

      this.draw_Line(header, col[1].sx, col[2].ex, head.depths[2], head.depths[2], '#bcbcbc')
      this.draw_Line(header, col[4].sx, col[9].ex, head.depths[2], head.depths[2], '#bcbcbc')

      // Depth 3
      let dY = [0,2,1,1,2,0,2,1,2,1]
      this.columns.forEach((col, c)=> {
        if(c > this.columns.length -2) return
        if(c==0) this.draw_Text(header, '', col.mx, head.height/2, head.tSize[0]+2, head.tColor[0], 'middle', col.name)
        else this.draw_Text(header, '', col.mx, head.tY[2], head.tSize[2], head.tColor[2], 'middle', col.name)

        let color = '#bcbcbc'
        if(dY[c]==1 || dY[c]==2) color = '#E0E0DF'
        this.draw_Line(header, col.ex, col.ex, head.depths[dY[c]], this.table.height, color)
      })

      // Progress
      this.draw_Text(header, '', (col[10].sx + 5), head.height - 6, 8, '#bcbcbc', 'middle', 0)
      this.draw_Text(header, '', (col[10].sx + col[10].width/2), head.height - 6, 8, '#bcbcbc', 'middle', 50)
      this.draw_Text(header, '', (col[10].ex - 5), head.height - 6, 8, '#bcbcbc', 'middle', 100)

    },

    
  }
}